import { render, staticRenderFns } from "./mainDealerPieChart.vue?vue&type=template&id=35c20d91&scoped=true"
import script from "./mainDealerPieChart.vue?vue&type=script&lang=js"
export * from "./mainDealerPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c20d91",
  null
  
)

export default component.exports